// @ts-nocheck
function toRgb(hex) {
  const r = (hex >> 16) & 255;
  const g = (hex >> 8) & 255;
  const b = hex & 255;

  return { r, g, b };
}

export function hexToRgb(hex, alpha = 1) {
  const { r, g, b } = toRgb(hex);

  return `rgba(${r},${g},${b},${alpha})`;
}
